import React from "react";
import "./style.scss";
import PropTypes from "prop-types";
export const DBButton = ({
    size,
    type,
    onClick,
    disabled,
    loading,
    className,
    outlined,
    children,
    icon,
    flipIcon,
    alt,
}) => {
    return (
        <button
            disabled={disabled}
            onClick={(e) => {
                e.preventDefault();
                !disabled && !loading && onClick();
            }}
            className={`db-button ${className} ${
                outlined ? "outlined" : ""
            } ${type} ${size}`}
        >
            {
                loading && <div class="loading"></div> // or other loading component
            }
            <div style={{ visibility: loading ? "hidden" : "visible" }}>
                {icon && (
                    <>
                        <div
                            className="db-button-icon"
                            style={{
                                transform: flipIcon
                                    ? "translateY(-50%) scaleX(-1)"
                                    : null,
                            }}
                        >
                            <img src={icon} alt={alt} />
                        </div>
                        <div className="db-button-icon-placeholder"></div>
                    </>
                )}
                {children}
            </div>
        </button>
    );
};

DBButton.propTypes = {
    children: PropTypes.string,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    type: PropTypes.oneOf(["primary", "secondary"]),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    className: PropTypes.string,
    outlined: PropTypes.bool,
    icon: PropTypes.string,
    flipIcon: PropTypes.bool,
};

DBButton.defaultProps = {
    children: "کلیک کنید",
    size: "medium",
    type: "primary",
};
